import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { authAPI } from '../../services/api';
import { useLanguage } from '../../context/LanguageContext';

const TwoFactorSetup = () => {
  const { t } = useLanguage();
  const [secret, setSecret] = useState('');
  const [uri, setUri] = useState('');
  const [code, setCode] = useState('');
  const [message, setMessage] = useState('');

  const start = async () => {
    const response = await authAPI.totpSetup();
    setSecret(response.data.secret);
    setUri(response.data.otpauth_uri);
  };

  const confirm = async (event) => {
    event.preventDefault();
    try {
      await authAPI.totpConfirm(code);
      setMessage(t('totp.enabled'));
    } catch (error) {
      setMessage(error.response?.data?.error || t('totp.badCode'));
    }
  };

  const skip = () => {
    sessionStorage.setItem('totp-skip', '1');
    window.location.assign('/admin');
  };

  return (
    <div className="admin-page">
      <h1>{t('totp.title')}</h1>
      <p>{t('totp.lead')}</p>
      <button type="button" className="pos-btn" onClick={start}>{t('totp.start')}</button>
      {uri && (
        <form onSubmit={confirm}>
          <QRCodeSVG value={uri} size={180} />
          <p>{t('totp.secret')}{secret}</p>
          <label>{t('totp.code')}
            <input value={code} onChange={(event) => setCode(event.target.value)} />
          </label>
          <button type="submit" className="pos-btn">{t('totp.confirm')}</button>
        </form>
      )}
      <button type="button" className="pos-btn secondary" onClick={skip}>{t('totp.later')}</button>
      {message && <p>{message}</p>}
    </div>
  );
};

export default TwoFactorSetup;
